export default __webpack_public_path__ + "static/media/EAST1030.34I-34171_-18418_0.7271ed38.jpg";